module.exports = __webpack_public_path__ + "img/生活配套_image.6ae775ed.png";